import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-otrodestino',
  templateUrl: './otrodestino.component.html',
  styleUrls: ['./otrodestino.component.css']
})
export class OtrodestinoComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OtrodestinoComponent>
  ) { }

  ngOnInit() {
  }

  cerrarventana() {
    this.dialogRef.close();
  }

}
